export const codes = [
    "en",
    // "ar",
    // "et",
    // "ja",
    // "nn_NO",
    // "sr_Latin",
    // "az",
    // "eu",
    // "ka",
    // "pl",
    // "sv",
    // "bg",
    // "fa",
    // "ko",
    // "pt_BR",
    // "th",
    // "ca",
    // "fi",
    // "lt",
    // "pt_PT",
    // "tr",
    // "cs",
    // "fr",
    // "lv",
    // "ro",
    // "uk",
    // "da",
    // "he",
    // "mn",
    // "ru",
    // "vi",
    // "de",
    // "hr",
    // "ms_MY",
    // "sk",
    // "zh_CN",
    // "el",
    // "hu",
    // "nb_NO",
    // "sl",
    // "zh_TW",
    // "id",
    // "ne",
    // "sq",
    // "es",
    // "it",
    // "nl",
    // "sr"
];
